import React from "react";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Breadcrumbs, Link, Typography, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router";

import { ORGANIZATIONS, PROJECTS } from "src/platform/constants/routes";

interface ProjectBreadcrumbsProps {
  orgAlias?: string;
}

export function ProjectBreadcrumbs({
  orgAlias,
}: ProjectBreadcrumbsProps): React.ReactElement {
  const theme = useTheme();
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ mb: theme.spacing(2) }}
    >
      <Link
        color="inherit"
        component={RouterLink}
        to={orgAlias ? ORGANIZATIONS.DETAILS.getPath(orgAlias) : "/"}
        sx={{ textDecoration: "none" }}
      >
        {orgAlias}
      </Link>
      <Link
        color="inherit"
        component={RouterLink}
        to={orgAlias ? PROJECTS.LIST.getPath(orgAlias) : "/"}
        sx={{ textDecoration: "none" }}
      >
        Projects
      </Link>
      <Typography color="text.primary">New project</Typography>
    </Breadcrumbs>
  );
}
